// 員工編輯預期排班的狀態資料

import * as types from '../actionType';

let initState = {
  events: [
  ],
  eventStartTime: "2018-11-01T00:00:00",
  eventEndTime: "2018-11-15T00:00:00"
};


function staffNextShiftState(state = initState, action) {
  switch (action.type) {
      case types.NEXT_SHIFT_SUCCESS: {
        return action.result;
      }
      case types.ADD_NEXT_WORK_TIME_SUCCESS: {
        let newEvens = [...state.events];
        newEvens.push(action.result);
        state.events = newEvens;
        return state;
      }
      case types.EDIT_NEXT_WORK_TIME_SUCCESS: {
        let newState = JSON.parse(JSON.stringify(state));
        let newEvents = [...newState.events];
        newEvents = newEvents.map((event) => {
          if (event.id === action.result.id) {
            return action.result;
          }
          return event;
        });
        newState.events = newEvents;
        return newState;
      }
      case types.DELETE_NEXT_WORK_TIME_SUCCESS: {
        let newState = JSON.parse(JSON.stringify(state));
        let newEvents = [...newState.events];
        newEvents = newEvents.filter(event => event.id !== Number(action.result.id));
        newState.events = newEvents;
        return newState;
      }
      default:
        return state;
  }
}


export default staffNextShiftState;